














import { Component, Vue } from 'vue-property-decorator'
import { DetailInfoItem, OperationItemType, OptionItemType } from '../../types/type'
import { findItemForTree, getNameTextInOptions } from '../../utils/toolsForCommon'
import { CommonModule, CanteenModule } from '../../store'
@Component({
  name: 'IncomeAndExpensesDetail',
  components: {
    'form-module-detail': () => import('../../components/common/formModuleDetail.vue')
  }
})
export default class IncomeAndExpensesDetail extends Vue {
  public loading = false
  public headerOperationListForIncomeAndExpensesDetail: Array<OperationItemType> = [
    {
      title: "<span class='el-icon-caret-left m_r5'></span>返回",
      key: 'back',
      type: 'primary',
      size: ''
    }
  ]
  public detailInfoList: Array<DetailInfoItem> = [
    {
      title: '收支流水记录基本信息',
      key: 'accessoryInfo',
      children: [
        {
          title: '学校',
          type: 'text',
          key: 'organizationName',
          value: ''
        },
        {
          title: '摘要',
          type: 'text',
          key: 'summary',
          value: ''
        },
        {
          title: '科目',
          type: 'text',
          key: 'subject',
          value: ''
        },
        {
          title: '时间',
          type: 'text',
          key: 'time',
          value: ''
        },
        {
          title: '收支',
          type: 'text',
          key: 'incOrExp',
          value: ''
        },
        {
          title: '资金形式',
          type: 'text',
          key: 'capitalType',
          value: ''
        },
        {
          title: '金额（元）',
          type: 'text',
          key: 'money',
          value: ''
        },
        {
          title: '数量',
          type: 'text',
          key: 'amount',
          value: ''
        },
        {
          title: '单位',
          type: 'text',
          key: 'unit',
          value: ''
        },
        {
          title: '票据类型',
          type: 'text',
          key: 'billType',
          value: ''
        },
        {
          title: '发票',
          type: 'photoForList',
          key: 'billImg',
          value: ''
        },
        {
          title: '发票编号',
          type: 'text',
          key: 'billNo',
          value: ''
        },
        {
          title: '工资单图片',
          type: 'photoForList',
          key: 'payrollImg',
          value: ''
        },
        {
          title: '转账截图',
          type: 'photoForList',
          key: 'transferImg',
          value: ''
        },
        {
          title: '凭证图片',
          type: 'photo',
          key: 'voucherImg',
          value: ''
        },
        {
          title: '备注',
          type: 'text',
          key: 'comment',
          value: ''
        }
      ]
    }
  ]
  // 枚举选项：
  public optionsForIncOrExp: Array<OptionItemType> = [
    {
      name: '收入',
      value: true
    },
    {
      name: '支出',
      value: false
    }
  ]
  public optionsForBillType: Array<OptionItemType> = [
    {
      name: '增值税发票',
      value: 1
    },
    {
      name: '自制凭证',
      value: 2
    },
    {
      name: '工资单',
      value: 3
    }
  ]

  get treeDataForOrganatizion () {
    return CommonModule.treeDataForOrganatizion
  }

  get treeDataForSubOrganatizion () {
    return CommonModule.treeDataForSubOrganatizion
  }

  get treeDataForDisposeNameSubject () {
    return CanteenModule.treeDataForDisposeNameSubject
  }

  async created () {
    await Promise.all([
      CommonModule.getTreeDataForOrganization(),
      CommonModule.getTreeDataForSubOrganization(),
      CanteenModule.getTreeDataForDisposeNameSubject()
    ])
    const { id } = (this as any).$route.query
    if (!id) return (this as any).$router.go(-1)
    if (id !== 'add') this.getDetailInfo()
  }

  async getDetailInfo () {
    try {
      this.loading = true
      const { id, orgId } = this.$route.query
      const params = {
        id,
        orgId
      }
      const { data: result } = await (this as any).$http.journalQuery(params)
      this.loading = false
      if (result.code !== 200) return this.$message.error(result.msg)
      const info = result.data.records[0] || {}
      this.detailInfoList = this.detailInfoList.map(item => {
        item.children = item.children.map(v => {
          const { key } = v
          switch (key) {
            case 'organizationName':
              const temporaryStorageForValue = findItemForTree(this.treeDataForOrganatizion, 'children', 'id', info['orgId'])
              v.value = temporaryStorageForValue['name']
              break
            case 'subject':
            case 'capitalType':
              const subjectItem = findItemForTree(this.treeDataForDisposeNameSubject, 'children', 'code', info[key])
              v.value = subjectItem['name']
              break
            case 'incOrExp':
              v.value = getNameTextInOptions(this.optionsForIncOrExp, info[key])
              break
            case 'billType':
              v.value = getNameTextInOptions(this.optionsForBillType, info[key])
              break
            case 'billImg':
            case 'payrollImg':
            case 'transferImg':
              v.value = info[key] ? (info[key]).split(',') : []
              break
            default:
              v.value = info[key]
              break
          }
          return v
        })
        return item
      })
    } catch (err) {
      console.log(err)
    }
  }

  operationForButton ({ key }) {
    switch (key) {
      case 'back':
        this.$router.go(-1)
        break
    }
  }
}
